import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-gantt-lines',
    templateUrl: './gantt-lines.component.html',
    styleUrls: ['./gantt-lines.component.scss'],
    standalone: false
})
export class GanttLinesComponent implements OnInit {

  @Input() hours: Array<number>;

  @Input() unit: number;
  
  constructor() { 
    
  }

  ngOnInit(): void {
  }
  
}
